// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Notifications from '@material-ui/icons/Notifications';

import loadNotifications from '../state/loadNotifications';
import markNotificationsAsViewed from '../state/markNotificationsAsViewed';

import BreadcrumbNav from '../../../view/nav/BreadcrumbNav';
import EmptyState from '../../../view/common/EmptyState';
import LoadingState from '../../../view/common/LoadingState';
import NotificationSettingsGuard from '../../notificationSettings/components/NotificationSettingsGuard';
import PrimaryButton from '../../../view/common/component/PrimaryButton';
import NotificationsCenterList from './NotificationsCenterList';
import NotificationsCenterControlBar from './NotificationsCenterControlBar';

import * as AppState from '../../../state/reducer/app/appState';
import * as LibraryState from '../../../state/reducer/library/library';

import Console from '../../../lib/debug';
import { isMessagingNotificationType } from '../constants';
import { FEATURES } from '../../features/components/constants';
import Alerts from './Alerts';

type Props = {
    notificationsList: Array<any>,
    dispatch: () => any
};

const crumbs = [
    {
        displayString: 'Notifications',
        link: `/notifications`,
        editable: false
    }
];

export class NotificationsCenterClass extends PureComponent<Props> {
    constructor(props: any) {
        super(props);
        LibraryState.fetchTeams();
        LibraryState.fetchAthletes();
        this.props.dispatch(loadNotifications());
        this.state = this.calculateState(props);
    }

    calculateState(props: Props) {
        return {
            notificationsList: props.notificationsList.filter(
                (notification: Notification) =>
                    !isMessagingNotificationType(
                        props.notificationsLookup[notification].type
                    )
            )
        };
    }

    componentWillReceiveProps(nextProps: Props) {
        if (nextProps.notificationsList !== this.props.notificationsList) {
            this.setState(this.calculateState(nextProps));
        }
    }

    componentDidMount() {
        const { dispatch, notificationsList } = this.props;
        if (notificationsList.length > 0) {
            dispatch(markNotificationsAsViewed());
        }
    }

    navigateToSettings() {
        AppState.navigate('/notification-settings');
    }

    getEmptyState() {
        const { appLoading } = this.props;
        const { notificationsList } = this.state;
        if (appLoading || notificationsList.length > 0) {
            return null;
        }

        const title = 'No Notifications';
        // eslint-disable-next-line max-len
        const text = `There are currently no notifications. You’ll \nsee them appear here for things like \ncomments on feeds and sessions, or when \nan athlete leaves you a message.`;

        const primaryButton = (
            <PrimaryButton onClick={this.navigateToSettings}>
                Go to Notification Settings
            </PrimaryButton>
        );

        return (
            <EmptyState
                title={title}
                text={text}
                icon={
                    <Notifications
                        style={{
                            fontSize: 48,
                            marginBottom: 14
                        }}
                    />
                }
            >
                <NotificationSettingsGuard settingsButton={primaryButton} />
            </EmptyState>
        );
    }

    getLoadingState() {
        if (!this.props.appLoading) {
            return null;
        }

        return <LoadingState />;
    }

    getNotificationsCenter() {
        const { notificationsLookup, appLoading } = this.props;

        const { notificationsList } = this.state;

        if (appLoading || notificationsList.length === 0) {
            return null;
        }

        let allAreRead = true;
        for (const notificationId of notificationsList) {
            const notification = notificationsLookup[notificationId];
            if (!notification.isRead) {
                allAreRead = false;
                break;
            }
        }

        return (
            <div>
                <div className="jumbotron">
                    <h1>Your Notifications</h1>
                    <NotificationsCenterControlBar disabled={allAreRead} />
                </div>
                <div className="notifications-layout">
                    <div>
                        <NotificationsCenterList
                            notificationsList={notificationsList}
                        />
                    </div>
                    <Alerts />
                </div>
            </div>
        );
    }

    render() {
        Console.render('Notifications Center');
        const notificationsCenter = this.getNotificationsCenter();
        const emptyState = this.getEmptyState();
        const loadingState = this.getLoadingState();

        return (
            <div className="notifications-view">
                <BreadcrumbNav crumbs={crumbs} />
                <div>
                    {notificationsCenter}
                    {emptyState}
                    {loadingState}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: {}, ownProps: any) => {
    return {
        ...ownProps,
        appLoading: state.app.appLoading,
        notificationsList: state.notifications.notificationsList,
        notificationsLookup: state.notifications.notificationsLookup,
        features: state.features
    };
};

export default connect(mapStateToProps)(NotificationsCenterClass);



// WEBPACK FOOTER //
// ./src/v5/notifications/components/NotificationsCenter.jsx